import c from '../../utils/c';

export function InputGroup({ children, className = '' }) {
  return <div className={c(className, 'mb-3')}>{children}</div>;
}
